import { Observable } from 'rxjs';

export interface SigninModel {
    username?: string;
    password?: string;
    captcha?: string;
}

export interface OrganizationDto {
    id: number;
    title: string;
}

export abstract class AuthenticationProvider {
    abstract getCaptcha(): Observable<Blob>;
    abstract signIn(signinModel: SigninModel): Observable<any>;
    abstract getUserOrganizations(): Promise<OrganizationDto[]>;
    abstract setUserOrganization(organizationId: number): Observable<any>;
    abstract changeUserPassword(currentPassword: string, newPassword: string): Observable<any>;
    abstract getUser(): Observable<UserIdentity>;
    abstract refreshAuthToken(): Observable<any>;
    abstract signOut(): Observable<any>;
}

export class UserIdentity {
    readonly firstName: string;
    readonly lastName: string;
    readonly permissions: string[];
    readonly forcePasswordChange: boolean;
    readonly activeOrganizationId: number;
    readonly activeOrganizationTitle: string;

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    constructor(
        firstName: string,
        lastName: string,
        permissions: string[],
        forcePasswordChange: boolean,
        activeOrganizationId: number,
        activeOrganizationTitle: string) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.permissions = permissions;
        this.activeOrganizationId = activeOrganizationId;
        this.activeOrganizationTitle = activeOrganizationTitle;
        this.forcePasswordChange = forcePasswordChange;
    }

    hasPermission(permission: string): boolean {
        if (Array.isArray(this.permissions)) {
            return this.permissions.some(x => x.toLowerCase() === permission.toLowerCase());
        } else {
            throw new Error('invalid or empty parameter: permission');
        }
    }
}
